import CategoriesSC from "./categories.styles";

const CATEGORIES = [
    {
        title: "Individual Counselling",
        description: "Personalized one-on-one sessions to explore self-growth and personal challenges.",
        emoji: "🤝",
    },
    {
        title: "Student Counselling",
        description: "Support for navigating the unique emotional and social hurdles of student life.",
        emoji: "🎒",
    },

    {
        title: "Anxiety and Stress Management",
        description: "Practical tools to manage daily stressors, panic, and persistent worry.",
        emoji: "🌿",
    },
    {
        title: "Depression Support",
        description: "Compassionate care for navigating low mood, lethargy, and emotional heaviness.",
        emoji: "😩",
    },
    {
        title: "Relationship and Family Concerns",
        description: "Guidance for improving communication, resolving conflict, and strengthening bonds.",
        emoji: "🏠",
    },
    {
        title: "Mindfulness and Wellbeing Training",
        description: "Developing presence, awareness, and habits to maintain long-term emotional and physical health.",
        emoji: "🧘",
    }
];

const CategoryGrid = () => {
    return (
        <CategoriesSC>
            <div className="grid-title">Healing for Every Chapter of Your Life</div>
            <div className="category-holder">
                {CATEGORIES.map((item, index) => (
                    <div className="category-card" key={index}>
                        <div className="category-emoji">
                            <span>{item.emoji}</span>
                        </div>

                        <h3 className="category-title">{item.title}</h3>

                        <p className="category-description">
                            {item.description}
                        </p>
                    </div>
                ))}
            </div>
        </CategoriesSC>
    );
}

export default CategoryGrid;
